{
  "rating-star-icon": {
    "text": {
      "review": "examen",
      "reviews": "revues"
    }
  }
}
